import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  TextField,
  Chip,
  FormHelperText,
} from "@mui/material";

import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import { Add } from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  boxShadow: "none",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const HobbiesForm = ({ onChildData }) => {
  const [selectedHobbies, setSelectedHobbies] = useState([]);
  const [customHobby, setCustomHobby] = useState("");
  const [customHobbies, setCustomHobbies] = useState([]);
  const [error, setError] = useState(false);

  const hobbiesList = [
    "Acting",
    "Art collecting",
    "Being a DJ",
    "Calligraphy",
    "Crocheting",
    "Dancing",
    "Designing clothing",
    "Drawing",
    "Freestyling",
    "Glassblowing",
    "Graphic design",
    "Jewelry making",
    "Improvisation",
    "LARPing",
    "Metalworking",
    "Needlepoint",
    "Origami",
    "Painting",
    "Photography",
    "Playing a musical instrument",
    "Podcasting",
    "Poetry",
    "Pottery",
    "Quilting",
    "Record collecting",
    "Scrapbooking",
    "Soap making",
    "Stand-up comedy",
    "Weaving",
    "Web design",
    "Welding",
    "Wood burning",
    "Woodworking",
    "Writing",
    "Baking",
    "Bread making",
    "Brewing",
    "Cheese-making",
    "Cooking",
    "Mixology",
    "Winemaking",
    "Wine tasting",
    "Billiards",
    "Board games",
    "Card games",
    "Chess",
    "Crossword puzzles",
    "Escape rooms",
    "Fantasy sports",
    "Jigsaw puzzles",
    "Lego sets",
    "Model trains",
    "Paintball",
    "Remote airplanes",
    "Remote cars",
    "Table tennis",
    "Trivia",
    "Video games",
    "Amateur radio",
    "Bonsai",
    "Book collecting",
    "Candle-making",
    "Election forecasting",
    "Focus groups",
    "Furniture restoration",
    "Genealogy",
    "Investing",
    "Journaling",
    "Karaoke",
    "Knitting",
    "Local historical society",
    "Makeup",
    "Movie reviews",
    "Museum visiting",
    "Reading",
    "Robot combat",
    "Taxidermy",
    "Thrifting",
    "Wikipedia editing",
    "Astronomy",
    "Beekeeping",
    "Bird watching",
    "Camping",
    "Car racing",
    "Composting",
    "Drones",
    "Farming",
    "Fishing",
    "Flying",
    "Gardening",
    "Geocaching",
    "Home improvement projects",
    "Launching rockets",
    "Metal detecting",
    "Meteorology",
    "National Park Travelers Club",
    "Sailing",
    "Scuba diving",
    "Shuffleboard",
    "Skydiving",
    "Traveling",
    "Vehicle restoration",
    "App making",
    "Electronics repair",
    "Hacking",
    "Video production",
    "Archery",
    "Backpacking",
    "Bowling",
    "Bungee jumping",
    "Crossfit",
    "Disc golfing",
    "Golfing",
    "Gymnastics",
    "Handball",
    "Hiking",
    "Horseback riding",
    "Ice skating",
    "Juggling",
    "Kayaking",
    "Kite surfing",
    "Martial arts",
    "Powerlifting",
    "Rock climbing",
    "Running",
    "Skiing",
    "Slacklining",
    "Snowboarding",
    "Surfing",
    "Swimming",
    "Water skiing",
    "Yoga",
    "Animal breeding",
    "Animal grooming",
    "Pet fostering",
  ];
  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedHobbies(typeof value === "string" ? value.split(",") : value);
    setError(false);
    onChildData({ interests: typeof value === "string" ? value.split(",") : value });
  };

  const handleCustomHobbyChange = (event) => {
    setCustomHobby(event.target.value);
    setError(false);
  };

  const addCustomHobby = () => {
    if (customHobby.trim()) {
      setCustomHobbies((prev) => [...prev, customHobby.trim()]);
      setCustomHobby("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const allHobbies = [...selectedHobbies, ...customHobbies];

    if (allHobbies.length === 0) {
      setError(true);
      return;
    }

    const output = `interests:\n  - ${allHobbies
      .map((hobby) => `"${hobby}"`)
      .join("\n  - ")}`;

    console.log(output);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3,pt:0,pb:2 }}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant="h6">Interests</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormControl fullWidth required error={error} sx={{ mb: 2 }}>
            <Select
              multiple
              value={selectedHobbies}
              onChange={handleSelectChange}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
            >
              {hobbiesList.map((hobby) => (
                <MenuItem key={hobby} value={hobby}>
                  <Checkbox checked={selectedHobbies.indexOf(hobby) > -1} />
                  <ListItemText primary={hobby} />
                </MenuItem>
              ))}
            </Select>
            {error && <FormHelperText>This field is required.</FormHelperText>}
            <small>
              <a
                href="https://www.indeed.com/career-advice/career-development/list-of-hobbies"
                target="_blank"
              >
                See Details
              </a>
            </small>
          </FormControl>

          <TextField
            fullWidth
            label="Add a Custom Hobby"
            variant="outlined"
            size="small"
            value={customHobby}
            onChange={handleCustomHobbyChange}
            sx={{ mb: 2 ,display:'none'}}
          />
          <Button variant="outlined" onClick={addCustomHobby} sx={{ mb: 2,display:'none' }}>
            Add Custom Hobby
          </Button>

          <Typography variant="h6" sx={{display:'none'}}>Custom Hobbies:</Typography>
          <Box sx={{ display: "none", flexWrap: "wrap", gap: 0.5 }}>
            {customHobbies.map((hobby) => (
              <Chip
                key={hobby}
                label={hobby}
                onDelete={() =>
                  setCustomHobbies(customHobbies.filter((h) => h !== hobby))
                }
              />
            ))}
          </Box>
        </AccordionDetails>
      </Accordion>

      <Button type="submit" variant="contained" sx={{ mt: 2, display: "none" }}>
        Submit
      </Button>
    </Box>
  );
};

export default HobbiesForm;
